import moment from "moment";

export const defineMonths = (initialMonth: moment.Moment, numberOfMonths: number): moment.Moment[] => {
  const ref = initialMonth.clone().startOf("month");
  return Array.from(
    { length: numberOfMonths },
    (_, i) => ref.clone().add(i, "month"));
}
